import TermPicker from './TermPicker';

export default TermPicker;
